<app-navbar-one></app-navbar-one>
<button class="qr-btn-fab" (click)="openQRPopup()" type="button" title="Share via QR Code">
    <i class="fas fa-qrcode"></i>
</button>
<div class="main-banner-area-two">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="main-banner-content">
                            <img src="assets/img/home-two/cesar.png"
                                class="img-logo  wow animate__animated animate__fadeInUp" data-wow-delay="0.6s"
                                alt="image" (click)="openQRPopup()">
                            <h1>Cesar Vega</h1>
                            <p style="font-size: 1.2rem;">Senior Software Engineer(Indepent Contractor)</p>
                            <p style="font-size: 1.2rem;">Software Engineer Consultant</p>
                            <p style="font-size: 1.2rem;">Freelance Software Developer</p>
                            <div class="banner-btn">
                                <a href="/assets/img/services-details/Resume_Cesar_Vega_PDF_.pdf" download target="_blank"
                                    class="default-btn">Download CV</a>
                                <a href="#footer" target="_blank"
                                    class="optional-btn">Contact Me</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="banner-image">
                            <img src="assets/img/home-two/1.png" class="wow animate__animated animate__fadeInUp"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-two/2.png" class="wow animate__animated animate__fadeInDown"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-two/3.png"
                                class="space_ship wow animate__animated animate__fadeInUp" data-wow-delay="0.6s"
                                alt="image">
                            <img src="assets/img/home-two/4.png" class="wow animate__animated animate__zoomIn"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-two/5.png" class="wow animate__animated animate__fadeInDown"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-two/main.png" class="wow animate__animated animate__zoomIn"
                                data-wow-delay="0.6s" alt="image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="banner-shape"><img src="assets/img/home-two/cloud.png" alt="image"></div>
    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/4.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/5.svg" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/6.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/7.png" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/8.png" alt="image"></div>
    </div>
</div>

<section class="features-section pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Who is <span>Cesar</span>?</h2>
            <p style="font-size: 1.5rem;">I'm a Senior Software Engineer with more than 10 years of experience in Angular +9, React, Typescript, web 
                applications. I have developed software tools for market research and 
                pharmaceutical name branding companies as well as health care complex software.</p>
            <div class="bar"></div>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="features-content">



                </div>
            </div>
        </div>
    </div>
</section>

<!-- Overlaying the video and close button to ensure visibility -->
<div class="video-container" style="display: none;" #videoContainer>
    <video #videoPlayer autoplay playsinline loop class="sm-embedded-video" controls>
        <source src="./assets/videos/AI_Promo.mp4" type="video/mp4">
    </video>
    <a class="close-btn" (click)="hideVideo()"><i class="flaticon-close"></i></a>
    <a class="sound-btn" (click)="toggleSound()"><i class="flaticon-speaker"></i></a> 

</div>




<section class="services-section bg-background pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>My strongest<span> Skills</span></h2>
            <p style="font-size: 1.5rem;">My strongest skills include both technical and human factors, encompassing my expertise in development frameworks, as well as my ability to work in and even lead teams.</p>
            <div class="bar"></div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-security"></i>
                    </div>
                    <h3>Fullstack Development and Frameworks</h3>
                    <p>Experiencia en la creación de aplicaciones modernas y responsivas usando Angular, React y varias herramientas de gestión de estado como Redux y NGRX. Expertise en SCSS, SASS y Tailwind para estilizado y mejoras en la UI/UX.</p>
                    <a routerLink="/development" class="read-btn">Learn More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon bg-deb0fe">
                         <i class="flaticon-analysis"></i>
                    </div>
                    <h3>Software Architecture and APIs</h3>
                    <p>Skilled in designing software architecture with modular and reactive design patterns. Experience in developing RESTful APIs, working with Firebase, Node.js, and various databases like MySQL.
                    </p>
                    <a routerLink="/Architecture/apis" class="read-btn">Learn More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon bg-79e8e2">
                        <i class="flaticon-cellphone"></i>
                    </div>
                    <h3>Tools and Version Control</h3>
                    <p>Proficient in using GitHub for version control and CI processes, with experience in CI/CD, Make.com for automation, and tools like Figma, Canva, and Netlify for design and deployment.</p>
                    <a routerLink="/version/control" class="read-btn">Learn More</a>
                </div>
            </div>
           <div class="col-lg-4 col-md-6 d-flex justify-content-center mx-auto">
                <div class="single-services-box">
                    <div class="icon bg-fcc774">
                        <i class="flaticon-optimize"></i>
                    </div>
                    <h3>Collaboration and Project Management</h3>
                    <p>Active participant in team meetings and project tracking using JIRA. Skilled in managing and deploying software features, including Docker image deployments for testing and QA.</p>
                    <a routerLink="/Proyect/management" class="read-btn">Learn More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 d-flex justify-content-center mx-auto">
                <div class="single-services-box">
                    <div class="icon bg-111774">
                        <i class="flaticon-quality"></i>
                    </div>
                    <h3>Artificial Intelligence Tools</h3>
                    <p>I’m someone passionate about technological advances, always striving to stay as up-to-date as possible with innovation.
                    </p>
                    <a routerLink="/ai" class="read-btn">Learn More</a>
                </div>
            </div>
        </div>
    </div>

</section>

<section class="technical-skills-section pt-24 pb-16 mt-4">
    <div class="container mx-auto">
        <div class="section-title text-center mb-12">
            <h2 class="text-3xl font-bold text-gray-800">Technical Skills</h2>
            <div class="w-24 h-1 bg-blue-600 mx-auto mt-4"></div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <!-- Angular & State Management -->
            <div class="skill-box bg-gray-50 p-6 rounded-lg shadow-md">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">Frontend Development & State Management</h3>
                <ul class="list-disc pl-5 space-y-3 text-gray-600">
                    <li>Experience in Angular (versions 2-17), RxJs, NGRX, and SIGNAL store for state management.</li>
                    <li>Experienced in React with strong expertise in TypeScript and JavaScript.</li>
                    <li>Experienced in managing application-wide state using Redux and context-based solutions.</li>
                    <li>Experienced in Xcode and Swift I build native iOS applications using Xcode and Swift, focusing on performance, design consistency, and seamless integration with the Apple ecosystem.</li>
                </ul>
            </div>

            <!-- Software Architecture & APIs -->
            <div class="skill-box bg-gray-50 p-6 rounded-lg shadow-md">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">Software Architecture & APIs</h3>
                <ul class="list-disc pl-5 space-y-3 text-gray-600">
                    <li>Experienced in software architecture and development, leveraging reactive design and modular patterns.</li>
                    <li>Experienced in RESTful API development, Firebase, and Node.js.</li>
                    <li>Experienced in develop RESTful APIs using Express.js in Node.js, ensuring fast, scalable, and secure backend services to support frontend functionality.</li>
                </ul>
            </div>

            <!-- Design & UI/UX -->
            <div class="skill-box bg-gray-50 p-6 rounded-lg shadow-md">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">Design & UI/UX</h3>
                <ul class="list-disc pl-5 space-y-3 text-gray-600">
                    <li>Experienced with SCSS preprocessors like SASS and Tailwind to create responsive designs.</li>
                    <li>Strong ability to enhance user experiences with animations and transformations.</li>
                </ul>
            </div>

            <!-- Databases & Version Control -->
            <div class="skill-box bg-gray-50 p-6 rounded-lg shadow-md">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">Databases & Version Control</h3>
                <ul class="list-disc pl-5 space-y-3 text-gray-600">
                    <li>Experienced in working with databases like MySQL and Firebase.</li>
                    <li>Proficient with GitHub for version control and GitHub Actions for Continuous Integration (CI).</li>
                </ul>
            </div>

            <!-- CI/CD & Tools -->
            <div class="skill-box bg-gray-50 p-6 rounded-lg shadow-md">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">CI/CD & Tools</h3>
                <ul class="list-disc pl-5 space-y-3 text-gray-600">
                    <li>Experience working with CI/CD workflows using GitOps and ArgoCD.</li>
                    <li>Deployed Docker images for testing and QA in dedicated environments.</li>
                    <li>Familiar with tools like Make.com, ChatGPT (Bots & Prompt Engineering), Figma, Canva, and Klavyo.</li>
                </ul>
            </div>

            <!-- Project Management -->
            <div class="skill-box bg-gray-50 p-6 rounded-lg shadow-md">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">Project Management</h3>
                <ul class="list-disc pl-5 space-y-3 text-gray-600">
                    <li>Strong background with active participation in daily meetings to track project progress using JIRA.</li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="choose-section pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Education & Skills</h2>
            <!-- <p>Discover the unique advantages of our AI services that set us apart in the tech industry.</p> -->
            <div class="bar"></div>
        </div>
        <div class="row align-items-center" style="display: flex;
        justify-content: center;">
            <div class="col-lg-4 col-md-6">
                <div class="choose-text">
                    <div class="icon">
                        <i class="flaticon-shared-folder"></i>
                    </div>
                    <h3>Bachelor of Computer Science, Software Engineer</h3>
                    <p>Florida International University - College of Engineering & Computing Science
                        (Miami-Florida)</p>
                </div>
                <div class="choose-text">
                    <div class="icon">
                        <i class="flaticon-laptop"></i>
                    </div>
                    <h3>Bachelor of Computer Science</h3>
                    <p>Del Valle University - College of Engineering & Computing Electronics (Cali -
                        Colombia)</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="image">
                    <img src="assets/img/mobile.png" alt="image">
                </div>
            </div>
            <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
                <div class="choose-text">
                    <div class="icon">
                        <i class="flaticon-quality"></i>
                    </div>
                    <h3>Other Skills</h3>
                    <p>Unreal Engine 4 Blueprints.</p>
                </div>
                <div class="choose-text">
                    <div class="icon">
                        <i class="flaticon-target"></i>
                    </div>
                    <h3>Hobbies</h3>
                    <p>Gym, Boxing, Ableton and Photoshop
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="experience-section pt-24 pb-16">
    <div class="container mx-auto">
        <div class="section-title text-center mb-12">
            <h2 class="text-3xl font-bold text-gray-800">Work Experience</h2>
            <div class="bar"></div>
            <div class="w-24 h-1 bg-blue-600 mx-auto mt-4"></div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <!-- RVO HEALTH -->
            <div class="experience-box bg-gray-50 p-6 rounded-lg shadow-md">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">RVO Health (07-05-2022 to Current)</h3>
                <ul class="list-disc pl-5 space-y-3 text-gray-600">
                    <li>I've been working at RVO Health for the past three years, where I enjoyed a great work environment, working closely with amazing developers to implement complex and structured workflows, using Jira and agile methodologies to coordinate sprints and teamwork, coordinating deployments, testing, and conducting collaborative QA and dev.</li>
                    <li>I design and develop efficient user interfaces and interactive applications using HTML, SCSS, Angular (including Angular Material and RxJS), as well as React with Redux for global state management.</li>
                    <li>Contributed to the implementation of two-factor authentication (2FA) from the frontend side, integrating it seamlessly with the existing authentication system. Ensured compatibility between both methods to support a gradual user migration without disrupting user experience or system security.</li>
                    <li>Developed React components following predefined architectural patterns and structures, using Redux for global state management. Integrated these components into larger modules while maintaining the established component hierarchy and ensuring design and functional consistency.</li>
                </ul>
            </div>

            <!-- BRAND INSTITUTE -->
            <div class="experience-box bg-gray-50 p-6 rounded-lg shadow-md">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">Brand Institute (09-18-2013 to 07-05-2022)</h3>
                <ul class="list-disc pl-5 space-y-3 text-gray-600">
                    <li>I have worked for the Brand Institute over 8 years. My responsibilities were to gather software requirements, plan, design, prototype, assign tasks to fellow developers, code reviews, code, test design and development of the software tools this company uses to manage clients and survey systems.</li>
                    <li>I'm responsible for creating efficient User Experience design and developing user interaction applications using HTML, SCSS, Angular Material, Angular Framework, RxJs operators to model, map, and change data streams and observables to maintain the data in sync across all components.</li>
                    <li>Enhanced application performance by Angular 9 Component-based development and changing legacy .NET software, where I remade entire applications from ASP to Angular.</li>
                    <li>Led the upgrade of several internal applications from early versions of Angular (v9+) to modern versions (up to Angular 17), resolving breaking changes, improving performance, and aligning the codebase with current best practices.</li>
                    <li>Responsible for styling, look, and feel of the web page with SASS that extends CSS with dynamic behavior such as variables, mixing, operations, and functions, Angular Material, and Bootstrap.</li>
                </ul>
            </div>

            <!-- BRENOCK TECHNOLOGY -->
            <div class="experience-box bg-gray-50 p-6 rounded-lg shadow-md">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">Brenock Technology (01-10-2013 to 08-25-2013)</h3>
                <ul class="list-disc pl-5 space-y-3 text-gray-600">
                    <li>I worked creating pages and modules for a legacy software (invoice management system) for Royal Caribbean.</li>
                    <li>Implemented the latest technologies at the time: double mustache, MVC, Bootstrap, Knockout.js, web API's, SQL Server.</li>
                    <li>Was responsible for creating user interfaces and designs.</li>
                    <li>Enhanced application performance using AJAX and Knockout.js.</li>
                    <li>Responsible for styling the web page with CSS.</li>
                </ul>
            </div>

            <!-- PICTURE MARKETING -->
            <div class="experience-box bg-gray-50 p-6 rounded-lg shadow-md">
                <h3 class="text-xl font-semibold text-gray-800 mb-4">Picture Marketing (08-12-2011 to 11-10-2012)</h3>
                <ul class="list-disc pl-5 space-y-3 text-gray-600">
                    <li>Developed mobile applications for Android and iOS SDK.</li>
                    <li>Created REST APIs for Web Applications using .NET.</li>
                    <li>Designed micro-websites for the company's clients using HTML, JavaScript, and .NET.</li>
                    <li>Generated Excel reports using third-party APIs and the PHP Excel library.</li>
                </ul>
            </div>
        </div>
    </div>
</section>



<app-qr-code-popup *ngIf="showQrCode" (closePopup)="showQrCode = false" [url]="qrUrl">
</app-qr-code-popup>
